import { create } from 'zustand';

const SUMMARY_GROUP_OPTIONS = [
  'Project',
  'Client',
  'User',
  'Tag',
  'Description',
  'Month',
  'Week',
  'Date',
] as const;

export type SummaryGroupOption = (typeof SUMMARY_GROUP_OPTIONS)[number];
export type GroupSlots = [SummaryGroupOption, SummaryGroupOption | null, SummaryGroupOption | null];

interface ReportsState {
  groupSlots: GroupSlots;
  setGroupSlots: (slots: GroupSlots) => void;
}

export const useReportsStore = create<ReportsState>()((set) => ({
  groupSlots: ['Project', null, null],
  setGroupSlots: (slots) => set({ groupSlots: slots }),
}));
